import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const promotionsModule = defineModule({
  name: "promotions",
  label: "Coupons & offers",
  requires: ["core", "accounts", "configuration", "audit", "catalog", "vendors", "products"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "marketing/coupons",
        permission: "promotions.view_coupon",
        page: () => import("./admin/CouponsPage"),
      },
      {
        path: "marketing/coupons/new",
        permission: "promotions.add_coupon",
        page: () => import("./admin/CouponEditorPage"),
      },
      {
        path: "marketing/coupons/:uid",
        permission: "promotions.view_coupon",
        page: () => import("./admin/CouponEditorPage"),
      },
    ],
    nav: [
      {
        id: "coupons",
        group: "business",
        label: "promotions:nav.coupons",
        icon: "tag",
        to: "/marketing/coupons",
        permission: "promotions.view_coupon",
        order: 8,
      },
    ],
  },
});
